import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SC, {
  InputContainer,
  IconButtonContainer,
  IconButton,
  HintMessage,
  CloseIcon
} from './styles';
import { noop } from '../../helpers';

const TextField = props => {
  return (
    <Fragment>
      <InputContainer>
        <SC.Input
          id={props.id}
          autoComplete={props.autoComplete}
          className={props.className}
          disabled={!props.isEditable || props.disabled}
          form={props.form}
          maxLength={props.maxLength}
          name={props.name}
          pattern={props.pattern}
          placeholder={props.placeholder}
          size={props.size}
          type={props.type}
          value={props.value}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onClick={props.onClick}
          onFocus={props.onFocus}
          onSelect={props.onSelect}
          onKeyDown={props.onKeyDown}
          onKeyPress={props.onKeyPress}
          onKeyUp={props.onKeyUp}
          isEditable={props.isEditable}
          showClear={props.showClear}
          rightIcon={props.rightIcon}
          validation={props.error ? 'danger' : props.validation}
          data-testid={props['data-testid']}
        />
        {props.showClear &&
          !props.disabled &&
          props.isEditable && (
            <IconButtonContainer
              onClick={props.onClear}
              stickyRight={props.rightIcon && props.showClear}
            >
              <IconButton>
                <CloseIcon />
              </IconButton>
            </IconButtonContainer>
          )}

        {props.rightIcon && (
          <IconButtonContainer>
            <IconButton>{props.rightIcon}</IconButton>
          </IconButtonContainer>
        )}
      </InputContainer>
      {props.hintMessage && (
        <HintMessage validation={props.validation}>
          {props.hintMessage}
        </HintMessage>
      )}
    </Fragment>
  );
};

TextField.defaultProps = {
  type: 'text',
  isEditable: true,
  showClear: false,
  onBlur: noop,
  onChange: noop,
  onClear: noop,
  onClick: noop,
  onFocus: noop,
  onSelect: noop,
  onKeyDown: noop,
  onKeyPress: noop,
  onKeyUp: noop
};

TextField.propTypes = {
  /** Extra class to apply to element */
  className: PropTypes.string,
  /** ID of input */
  id: PropTypes.string,
  /** Disable the element */
  disabled: PropTypes.bool,
  /** Maximum value length */
  maxLength: PropTypes.number,
  /** Name of input field */
  name: PropTypes.string,
  /** Placeholder text */
  placeholder: PropTypes.string,
  /** Value binded to this element */
  value: PropTypes.string,
  /** On blur function */
  onBlur: PropTypes.func,
  /** On change function */
  onChange: PropTypes.func,
  /** On click function */
  onClick: PropTypes.func,
  /** On focus function */
  onFocus: PropTypes.func,
  /** On select function */
  onSelect: PropTypes.func,
  /** On key down function */
  onKeyDown: PropTypes.func,
  /** On key press function */
  onKeyPress: PropTypes.func,
  /** On key up function */
  onKeyUp: PropTypes.func,
  /** Is Editable
   * Presentational effect for a disabled field.
   * `isEditable={false}` forces the textfield to disabled.
   * Intended present the text field content presentational purpose only
   **/
  isEditable: PropTypes.bool,
  /** Error state *This prop will be gradually deprecated in future versions. Use validation='danger' instead**/
  error: PropTypes.bool,
  /** Input Type */
  type: PropTypes.string,
  /** Show button to clear the field
   * When set to true, a button icon is shown, which when clicked, clears the value in the text field.
   * The button icon remains hidden when:
   *
   * - the field is disabled
   * - the field is not editable
   **/
  showClear: PropTypes.bool,
  /** On clear button click callback */
  onClear: PropTypes.func,
  /** Type of TextField's validation state */
  validation: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
  /** Hint message displayed under TextField */
  hintMessage: PropTypes.string,
  /** Identifier for writing testcases */
  'data-testid': PropTypes.string
};

TextField.legacyName = 'ux-input-box';
export default TextField;
